import { data } from '../../svg/Availability/data';
import { makeIcon } from '../makeIcon';

export const Availability = makeIcon(data, 'availability', 'Availability');

export default Availability;
